(() => {
  const start = (root) => {
    if (root.dataset.motorReady) return;
    root.dataset.motorReady = 'true';
    root.querySelectorAll('[data-motor-image]').forEach(button => {
      button.addEventListener('click', () => {
        const link = root.querySelector('.mx-motor-product__main-image');
        const image = link?.querySelector('img');
        if (!image) return;
        image.removeAttribute('srcset');
        image.src = button.dataset.motorImage;
        image.alt = button.dataset.motorAlt;
        link.href = button.dataset.motorFull;
        root.querySelectorAll('[data-motor-image]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      });
    });
    root.querySelector('[data-motor-variant]')?.addEventListener('change', event => {
      const option = event.target.selectedOptions[0];
      const button = root.querySelector('[data-motor-submit]');
      root.querySelector('[data-motor-price]').textContent = option.dataset.price;
      button.disabled = option.dataset.available !== 'true';
      root.dataset.preorder = option.dataset.preorder;
      const deliveryProperty = root.querySelector('[data-motor-delivery-property]');
      const hideDelivery = option.dataset.stock === 'true' || !deliveryProperty.value;
      root.querySelector('[data-motor-delivery-note]').hidden = hideDelivery;
      root.querySelector('[data-motor-stock-note]').hidden = option.dataset.stock !== 'true';
      deliveryProperty.disabled = hideDelivery;
      button.textContent = button.disabled ? root.dataset.unavailableLabel : root.dataset.preorder === 'true' ? root.dataset.preorderLabel : root.dataset.addLabel;
    });
  };
  document.querySelectorAll('[data-motor-product]').forEach(start);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-motor-product]').forEach(start));
})();

